import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withFirebase } from '../../firebase';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import uuid from 'react-uuid'
import Loader from 'react-loader-spinner';
import '@lourenci/react-kanban/dist/styles.css'
import { generateEliminationBoard } from '../MatchesUtil';
import EliminationBoard from '../Board/EliminationBoard';
import matchdaysJson from '../../../constants/matchdays.json';
import ModalConfirmCustom from '../../useful/ModalConfirmCustom';

const EliminationForm = (props) => {

    const userId = props.firebase.auth.currentUser.uid; // user auth uid
    const { tournament, teams, showModal } = props;

    useEffect(() => {
        const _board = generateEliminationBoard(teams);
        setDataBoard(_board);
    }, [teams])

    const [loading, setloading] = useState(false);
    const [dataBoard, setDataBoard] = useState(null);

    const [confirmShow, setConfirmShow] = useState(false);

    const nTeams = teams.length;
    // check if nTeams is power of 2
    if (nTeams < 2 || nTeams > 128 || !(Math.log2(nTeams) % 1 === 0)) {
        return (
            <div className="row nav justify-content-center small">
                <span className="col-12 col-md-9 text-secondary font-italic text-center font-italic pt-2">
                    La cantidad de equipos no es correcta para este tipo de competición. Debe contar con 2, 4, 8, 16, 32, 64 o 128 equipos.
                </span>
            </div>
        )
    }

    const onSubmit = () => {
        setConfirmShow(true);
    }

    const generateMatches = () => {
        setConfirmShow(false);
        //check amount of teams > 1

        const matchdayList = matchdaysJson.elimination;
        const columnId = dataBoard.columnId;
        const column = dataBoard[columnId];
        let cards = column.cards;

        if (cards.length >= 2 && cards.length <= 128 && (Math.log2(nTeams) % 1 === 0)) {

            setloading(true);

            //generate matches...
            try {
                const batch = props.firebase.batch();

                // generate firs round
                let matchdayTitle = matchdayList["" + cards.length];
                let matchdayIndex = 10000;

                let matchIndex = 0;

                let newCards = [];

                let nextMatchUid = null;
                for (let i = 0; i < cards.length; i += 2) {
                    if (newCards.length % 2 === 0)
                        nextMatchUid = uuid();

                    let teamA = cards[i];
                    let teamB = cards[i + 1];
                    const match = {
                        userUid: userId,
                        tournamentUid: tournament.uid,
                        index: matchIndex++,
                        teamA: teamA.id,
                        teamB: teamB.id,
                        matchday: {
                            index: matchdayIndex,
                            title: matchdayTitle
                        },
                        nextMatchUid: nextMatchUid
                    };
                    batch.set(props.firebase.matchDoc(userId, tournament.uid, uuid()), match);
                    newCards.push(nextMatchUid);
                }

                // generate others round with empty teams
                while (newCards.length > 1) {
                    // generate other match without teams
                    matchdayTitle = matchdayList["" + newCards.length];
                    matchdayIndex++;

                    matchIndex = 0;

                    cards = newCards;
                    newCards = [];

                    let nextMatchUid = null;
                    for (let i = 0; i < cards.length; i += 2) {
                        const matchUid = cards[i];
                        if (newCards.length % 2 === 0)
                            nextMatchUid = uuid();

                        const match = {
                            userUid: userId,
                            tournamentUid: tournament.uid,
                            index: matchIndex++,
                            matchday: {
                                index: matchdayIndex,
                                title: matchdayTitle
                            },
                            nextMatchUid: nextMatchUid
                        };
                        batch.set(props.firebase.matchDoc(userId, tournament.uid, matchUid), match);
                        newCards.push(nextMatchUid);
                    }
                }



                // set matchesGenerated to tournament item...
                batch.update(props.firebase.tournamentDoc(userId, tournament.uid), { matchesGenerated: true });

                batch.commit().then(() => {
                    setloading(false);
                }).catch(error => {
                    setloading(false);
                    console.log("Error: ", error);
                    showModal("Error", "Ocurrió un error al generar los partidos. Compruebe los datos e intentelo de nuevo.")
                });
            } catch (error) {
                setloading(false);
                console.log("Error: ", error);
                showModal("Error", "Ocurrió un error al generar los partidos. Compruebe los datos e intentelo de nuevo.")
            }

        } else {
            showModal("Información", "La cantidad de equipos no es suficiente.");
        }

    }

    return (
        <div className="col small" >

            <div className="row nav justify-content-center">
                <span className="col-12 col-md-9 text-secondary font-italic text-center font-italic">
                    Organiza los cruces como considere moviendo los equipos al lugar correspondiente. Una ves generado los partidos, los cambios lo debrá realizar de forma manual modificando cada partido por separado.
                </span>
            </div>

            {!(loading) ?
                <div className="row mt-2">

                    <div className="col-12 p-0 nav justify-content-center">
                        <button onClick={onSubmit} className="col-auto btn btn-sm btn-success m-1">
                            <FontAwesomeIcon className="mr-2" icon={faCheck} />
                            <span>Generar Partidos</span>
                        </button>
                    </div>

                    {(!!dataBoard) ?
                        <EliminationBoard setDataBoard={setDataBoard} dataBoard={dataBoard} />
                        :
                        <></>
                    }

                </div>
                :
                <div className="col-12 nav justify-content-center">
                    <Loader className="m-2"
                        type="ThreeDots"
                        color="#263238"
                        height={30}
                        width={60}
                        timeout={0} />
                </div>
            }

            {/* EliminationConfirm Modal */}
            <ModalConfirmCustom
                show={confirmShow}
                onClose={() => setConfirmShow(false)}
                onConfirm={generateMatches}
            >
                <p className="card-title font-weight-bolder">Generar Partidos</p>

                {/* <div className="text-black-50 font-italic small mb-3">
                    <FontAwesomeIcon className="text-break mr-1" icon={faExclamationTriangle} />
                    <span>El campo <strong>"Modalidad"</strong> no podrá ser modificado.</span>
                </div> */}

                <p className="small card-text text-break">Está seguro que desea generar los partidos?</p>

            </ModalConfirmCustom>


        </div >
    );
}

export default withFirebase(EliminationForm);


